<%= form_with(model: table, class: "contents") do |form| %>
  <% if table.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(table.errors.count, "error") %> prohibited this table from being saved:</h2>

      <ul class="list-disc ml-6">
        <% table.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :option_id %>
    <%= form.text_field :option_id, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": table.errors[:option_id].none?, "border-red-400 focus:outline-red-600": table.errors[:option_id].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :row %>
    <%= form.number_field :row, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": table.errors[:row].none?, "border-red-400 focus:outline-red-600": table.errors[:row].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :col %>
    <%= form.number_field :col, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": table.errors[:col].none?, "border-red-400 focus:outline-red-600": table.errors[:col].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :number %>
    <%= form.number_field :number, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": table.errors[:number].none?, "border-red-400 focus:outline-red-600": table.errors[:number].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :size %>
    <%= form.number_field :size, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": table.errors[:size].none?, "border-red-400 focus:outline-red-600": table.errors[:size].any?}] %>
  </div>

  <div class="my-5 flex items-center gap-2">
    <%= form.label :locked %>
    <%= form.checkbox :locked, class: ["block shadow-sm rounded-md border order-first h-5 w-5", {"border-gray-400 focus:outline-blue-600": table.errors[:locked].none?, "border-red-400 focus:outline-red-600": table.errors[:locked].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
